enum TargetType {
  TEAM = "team",
  MEMBERS = "members",
  INDIVIDUAL = "individual",
}

export default TargetType;
